'use strict';
angular.module('licensure.internal')
    .controller('InternalMergeTemplate', ['$scope', 'MergeContactGroups', 'MergeFields', '$filter', '$rootScope', function (
        $scope,
        MergeContactGroups,
        MergeFields,
        $filter,
        $rootScope) {
        $scope.addressStringToArray = function (varName, isGroup) {
            if (isGroup) {
                if ($scope.mergeTemplate[varName] != null) {
                    var arr = $scope.mergeTemplate[varName].split(',');
                    for (var i = 0, l = arr.length; i < l; i++) {
                        MergeContactGroups.getByID(arr[i]).then(function (group) {
                            $scope.tempMergeTemplate[varName].push({
                                id: group.id,
                                name: group.name,
                                group: true
                            });
                        })
                    }
                }
            } else {
                if ($scope.mergeTemplate[varName] != null) {
                    var arr = $scope.mergeTemplate[varName].split(',');
                    for (var i = 0, l = arr.length; i < l; i++) {
                        $scope.tempMergeTemplate[varName].push({
                            id: arr[i],
                            name: arr[i],
                            group: false
                        });
                    }
                }
            }
        };

        $scope.emailProviderEnabled = $rootScope.enterprise.settings.email_provider_enabled;
        $scope.emailProviderFromAddress = $rootScope.enterprise.settings.email_provider_from_address;

        $scope.vm = {
            toAddressForm: null,
            fromAddressForm: null
        }
        $scope.merge_objects = [];
        $scope.documents = [];
        $scope.contact_groups = [];
        $scope.contacts = [];
        $scope.contactOptions = [];
        $scope.tempMergeTemplate = {};
        $scope.tempMergeTemplate = angular.copy($scope.mergeTemplate);
        $scope.tempMergeTemplate.to_address = [];
        $scope.tempMergeTemplate.from_address = [];
        $scope.tempMergeTemplate.cc_address = [];
        $scope.tempMergeTemplate.bcc_address = [];
        $scope.tempMergeTemplate.replyto_address = [];
        $scope.tempMergeTemplate.to_contact_groups = [];
        $scope.tempMergeTemplate.from_contact_groups = [];
        $scope.tempMergeTemplate.cc_contact_groups = [];
        $scope.tempMergeTemplate.bcc_contact_groups = [];
        $scope.tempMergeTemplate.replyto_contact_groups = [];
        $scope.addressStringToArray('to_address', false);
        $scope.addressStringToArray('from_address', false);
        $scope.addressStringToArray('cc_address', false);
        $scope.addressStringToArray('bcc_address', false);
        $scope.addressStringToArray('replyto_address', false);
        $scope.addressStringToArray('to_contact_groups', true);
        $scope.addressStringToArray('from_contact_groups', true);
        $scope.addressStringToArray('cc_contact_groups', true);
        $scope.addressStringToArray('bcc_contact_groups', true);
        $scope.addressStringToArray('replyto_contact_groups', true);
        MergeFields.get($scope.mergeIdName).then(function (fields) {
            $scope.merge_fields = fields;
        });
        MergeContactGroups.get($scope.mergeIdName).then(function (groups) {
            groups.forEach(function (group) {
                $scope.contacts.push({ id: group.id, name: group.name, group: true });
            })
            $scope.contactOptions = angular.copy($scope.contacts);
        });
        $scope.addressArrayToString = function (added, type, group) {
            var list = "";
            var groupList = "";
            var listLocation = type.concat('_address')
            var groupListLocation = type.concat('_contact_groups')
            added.forEach(function (address) {
                if (address != null && address.id != '') {
                    if (group) {
                        if (groupList != '') { groupList += ',' }
                        groupList += address.id;
                    } else {
                        if (list != '') { list += ',' }
                        list += address.name;
                    }
                }
            });
            if (group) {
                $scope.mergeTemplate[groupListLocation] = groupList;
                if (!$scope.mergeTemplate[groupListLocation].replace(/\s/g, '').length) {
                    $scope.mergeTemplate[groupListLocation] = null;
                }
            }
            if (!group) {
                $scope.mergeTemplate[listLocation] = list;
                if (!$scope.mergeTemplate[listLocation].replace(/\s/g, '').length) {
                    $scope.mergeTemplate[listLocation] = null;
                }
            }
            $scope.vm.toAddressForm.$setValidity("required", ($scope.tempMergeTemplate.to_address != null && $scope.tempMergeTemplate.to_address.length > 0) || ($scope.tempMergeTemplate.to_contact_groups != null && $scope.tempMergeTemplate.to_contact_groups.length > 0));
            if (!$scope.emailProviderEnabled) {
                $scope.vm.fromAddressForm.$setValidity("required", ($scope.tempMergeTemplate.from_address != null && $scope.tempMergeTemplate.from_address.length > 0) || ($scope.tempMergeTemplate.from_contact_groups != null && $scope.tempMergeTemplate.from_contact_groups.length > 0));
            }
        };
        $scope.addAddress = function (tempMergeTemplate, type) {
            if (type == 'to') {
                if (tempMergeTemplate.to_add.group) {
                    tempMergeTemplate.to_contact_groups.push(angular.copy(tempMergeTemplate.to_add));
                    $scope.addressArrayToString(tempMergeTemplate.to_contact_groups, 'to', true);
                } else {
                    tempMergeTemplate.to_address.push(angular.copy(tempMergeTemplate.to_add));
                    $scope.addressArrayToString(tempMergeTemplate.to_address, 'to', false);
                }
                tempMergeTemplate.to_add = null;
                tempMergeTemplate.newToAddress = false;
            } else if (type == 'from') {
                if (tempMergeTemplate.from_add.group) {
                    tempMergeTemplate.from_contact_groups.push(angular.copy(tempMergeTemplate.from_add));
                    $scope.addressArrayToString(tempMergeTemplate.from_contact_groups, 'from', true);
                } else {
                    tempMergeTemplate.from_address.push(angular.copy(tempMergeTemplate.from_add));
                    $scope.addressArrayToString(tempMergeTemplate.from_address, 'from', false);
                }
                tempMergeTemplate.from_add = null;
                tempMergeTemplate.newFromAddress = false;
            } else if (type == 'cc') {
                if (tempMergeTemplate.cc_add.group) {
                    tempMergeTemplate.cc_contact_groups.push(angular.copy(tempMergeTemplate.cc_add));
                    $scope.addressArrayToString(tempMergeTemplate.cc_contact_groups, 'cc', true);
                } else {
                    tempMergeTemplate.cc_address.push(angular.copy(tempMergeTemplate.cc_add));
                    $scope.addressArrayToString(tempMergeTemplate.cc_address, 'cc', false);
                }
                tempMergeTemplate.cc_add = null;
                tempMergeTemplate.newCCAddress = false;
            } else if (type == 'bcc') {
                if (tempMergeTemplate.bcc_add.group) {
                    tempMergeTemplate.bcc_contact_groups.push(angular.copy(tempMergeTemplate.bcc_add));
                    $scope.addressArrayToString(tempMergeTemplate.bcc_contact_groups, 'bcc', true);
                } else {
                    tempMergeTemplate.bcc_address.push(angular.copy(tempMergeTemplate.bcc_add));
                    $scope.addressArrayToString(tempMergeTemplate.bcc_address, 'bcc', false);
                }
                tempMergeTemplate.bcc_add = null;
                tempMergeTemplate.newBCCAddress = false;
            } else if (type == 'replyto') {
                if (tempMergeTemplate.replyto_add.group) {
                    tempMergeTemplate.replyto_contact_groups.push(angular.copy(tempMergeTemplate.replyto_add));
                    $scope.addressArrayToString(tempMergeTemplate.replyto_contact_groups, 'replyto', true);
                } else {
                    tempMergeTemplate.replyto_address.push(angular.copy(tempMergeTemplate.replyto_add));
                    $scope.addressArrayToString(tempMergeTemplate.replyto_address, 'replyto', false);
                }
                tempMergeTemplate.replyto_add = null;
                tempMergeTemplate.newReplyToAddress = false;
            }
            $scope.vm.toAddressForm.$setValidity("required", ($scope.tempMergeTemplate.to_address != null && $scope.tempMergeTemplate.to_address.length > 0) || ($scope.tempMergeTemplate.to_contact_groups != null && $scope.tempMergeTemplate.to_contact_groups.length > 0));
            if (!$scope.emailProviderEnabled) {
                $scope.vm.fromAddressForm.$setValidity("required", ($scope.tempMergeTemplate.from_address != null && $scope.tempMergeTemplate.from_address.length > 0) || ($scope.tempMergeTemplate.from_contact_groups != null && $scope.tempMergeTemplate.from_contact_groups.length > 0));
            }
        }
        $scope.remove = function (array, item, type) {
            array.splice(array.indexOf(item), 1);
            if (item.group) {
                $scope.addressArrayToString(array, type, true)
            }
            else {
                $scope.addressArrayToString(array, type, false)
            }
            $scope.vm.toAddressForm.$setValidity("required", ($scope.tempMergeTemplate.to_address != null && $scope.tempMergeTemplate.to_address.length > 0) || ($scope.tempMergeTemplate.to_contact_groups != null && $scope.tempMergeTemplate.to_contact_groups.length > 0));
            if (!$scope.emailProviderEnabled) {
                $scope.vm.fromAddressForm.$setValidity("required", ($scope.tempMergeTemplate.from_address != null && $scope.tempMergeTemplate.from_address.length > 0) || ($scope.tempMergeTemplate.from_contact_groups != null && $scope.tempMergeTemplate.from_contact_groups.length > 0));
            }
        }
        $scope.optionChange = function (viewValue) {
            $scope.contactOptions = angular.copy($scope.contacts);
            if (viewValue != null && viewValue != '' && validateEmail(viewValue)) {
                $scope.contactOptions.push({
                    id: viewValue,
                    name: viewValue,
                    group: false
                });
            }
        }
        $scope.addMergeField = function (field, mergeTemplate) {
            if (mergeTemplate.gotosubject) {
                if (mergeTemplate.subject == null) {
                    mergeTemplate.subject = field.merge_name;
                } else {
                    mergeTemplate.subject += field.merge_name;
                }
            } else {
                if (mergeTemplate.message == null) {
                    mergeTemplate.message = field.merge_name;
                } else {
                    mergeTemplate.message += field.merge_name;
                }
            }
        }
        var unMerge = function (string) {
            if (string != null) {
                if ($scope.merge_objects != null) {
                    $scope.merge_objects.forEach(function (object) {
                        if (object.merge_name != null && object.value != null && string.indexOf(object.merge_name) >= 0) {
                            var value = object.value;
                            if (value.substr(0, 3) == '<p>') {
                                value = value.substr(3);
                            }
                            if (value.substr(-4, 4) == '</p>') {
                                value = value.substr(0, value.length - 4);
                            }
                            if (angular.isString(value)) {
                                var re = new RegExp(object.merge_name.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g');
                                string = string.replace(re, value);
                            }
                        }
                    })
                }
                if ($scope.merge_fields != null) {
                    $scope.merge_fields.forEach(function (field) {
                        if ($scope.mergeTemplateObject != null && $scope.mergeTemplateObject[field.json] !== undefined && field.merge_name != null && !field.multiple && string.indexOf(field.merge_name) >= 0) {
                            var value = $scope.mergeTemplateObject[field.json] == null ? '' : $scope.mergeTemplateObject[field.json];
                            if (isValidDate(value)) {
                                value = $filter('date')(value, 'MM/dd/yyyy');
                            }
                            if (angular.isString(value)) {
                                var re = new RegExp(field.merge_name.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g');
                                string = string.replace(re, value);
                            }
                        }
                    })
                }
            } else {
                string = '';
            }
            return string;
        }
    }])
    .directive('internalMergeTemplate', [function () {
        return {
            scope: {
                mergeTemplate: "=?",
                mergeIdName: "=?"
            },
            templateUrl: paths.app + 'components/merge-template/merge-template.html',
            controller: 'InternalMergeTemplate'
        };
    }]);